/**
 * @generated SignedSource<<bbd144734b2a402bbf52d238d3429196>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PromoCodeCalculationType = "BOOKING" | "SINGLE_ITEM" | "SINGLE_ROUND";
export type PromoCodeDiscountType = "FIXED" | "PERCENTAGE";
export type ApplyPromoCodeToBookingInput = {
  bookingId: string;
  promoCode?: string | null | undefined;
};
export type useApplyPromoCodeToBookingMutation$variables = {
  input: ApplyPromoCodeToBookingInput;
};
export type useApplyPromoCodeToBookingMutation$data = {
  readonly responsePayload: {
    readonly booking: {
      readonly appliedPromoCode: {
        readonly calculationType: PromoCodeCalculationType;
        readonly code: string;
        readonly discountAmount: number;
        readonly discountType: PromoCodeDiscountType;
        readonly id: string;
      } | null | undefined;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"promoCodeAnalytics_booking" | "useGetSummaryCalculations_Booking">;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type useApplyPromoCodeToBookingMutation = {
  response: useApplyPromoCodeToBookingMutation$data;
  variables: useApplyPromoCodeToBookingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discountType",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discountAmount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "active",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalDiscount",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaxes",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appliedAmount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "squareExternalId",
  "storageKey": null
},
v20 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AppliedDiscount",
    "kind": "LinkedField",
    "name": "appliedDiscounts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amountCents",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "squareExternalDiscountId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v21 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "BookingLineItem",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "RoundLineItem",
  "abstractKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calculationType",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "OrderDiscountConnection",
  "kind": "LinkedField",
  "name": "orderDiscounts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderDiscountEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderDiscount",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v6/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "LineItemGroup",
  "kind": "LinkedField",
  "name": "lineItemGroups",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "lineItems",
      "plural": true,
      "selections": [
        (v24/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "ServiceChargeConnection",
  "kind": "LinkedField",
  "name": "serviceCharges",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ServiceChargeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v24/*: any*/),
            (v18/*: any*/),
            (v6/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useApplyPromoCodeToBookingMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "ApplyPromoCodeToBookingPayload",
        "kind": "LinkedField",
        "name": "applyPromoCodeToBooking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineDataFragmentSpread",
                "name": "promoCodeAnalytics_booking",
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PromoCode",
                    "kind": "LinkedField",
                    "name": "appliedPromoCode",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "startSlot",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "agenda",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Facility",
                            "kind": "LinkedField",
                            "name": "facility",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Department",
                                "kind": "LinkedField",
                                "name": "department",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "promoCodeOrders",
                    "args": (v13/*: any*/),
                    "concreteType": "OrderConnection",
                    "kind": "LinkedField",
                    "name": "orders",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrderEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Order",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineDataFragmentSpread",
                                "name": "getAggregatedOrderFinancialSummary_order",
                                "selections": [
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderDiscountConnection",
                                    "kind": "LinkedField",
                                    "name": "orderDiscounts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrderDiscountEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrderDiscount",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v17/*: any*/),
                                              (v18/*: any*/),
                                              (v19/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LineItemGroup",
                                    "kind": "LinkedField",
                                    "name": "lineItemGroups",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "lineItems",
                                        "plural": true,
                                        "selections": [
                                          (v21/*: any*/),
                                          (v22/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ServiceChargeConnection",
                                    "kind": "LinkedField",
                                    "name": "serviceCharges",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ServiceChargeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "args": null,
                                "argumentDefinitions": []
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "orders(active:true,first:20)"
                  }
                ],
                "args": null,
                "argumentDefinitions": []
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useGetSummaryCalculations_Booking"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PromoCode",
                "kind": "LinkedField",
                "name": "appliedPromoCode",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useApplyPromoCodeToBookingMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "ApplyPromoCodeToBookingPayload",
        "kind": "LinkedField",
        "name": "applyPromoCodeToBooking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              (v6/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isBooking"
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PromoCode",
                "kind": "LinkedField",
                "name": "appliedPromoCode",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v6/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "startSlot",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agenda",
                    "kind": "LinkedField",
                    "name": "agenda",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Facility",
                        "kind": "LinkedField",
                        "name": "facility",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Department",
                            "kind": "LinkedField",
                            "name": "department",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "promoCodeOrders",
                "args": (v13/*: any*/),
                "concreteType": "OrderConnection",
                "kind": "LinkedField",
                "name": "orders",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Order",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "orders(active:true,first:20)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BookingPaymentRequirements",
                "kind": "LinkedField",
                "name": "paymentRequirements",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prePaymentRequirement",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalDueAfterCredits",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderConnection",
                "kind": "LinkedField",
                "name": "orders",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Order",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrderPaymentConnection",
                            "kind": "LinkedField",
                            "name": "orderPayments",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderPaymentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderPayment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SquareGiftCard",
                                        "kind": "LinkedField",
                                        "name": "squareGiftCard",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8ff2a76df4b081d6f40259120a930053",
    "id": null,
    "metadata": {},
    "name": "useApplyPromoCodeToBookingMutation",
    "operationKind": "mutation",
    "text": "mutation useApplyPromoCodeToBookingMutation(\n  $input: ApplyPromoCodeToBookingInput!\n) {\n  responsePayload: applyPromoCodeToBooking(input: $input) {\n    success\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    booking {\n      __typename\n      id\n      ...promoCodeAnalytics_booking\n      ...useGetSummaryCalculations_Booking\n      appliedPromoCode {\n        id\n        code\n        discountType\n        discountAmount\n        calculationType\n      }\n    }\n  }\n}\n\nfragment getAggregatedOrderFinancialSummary_order on Order {\n  total\n  totalDiscount\n  totalTaxes\n  orderDiscounts {\n    edges {\n      node {\n        appliedAmount\n        amount\n        squareExternalId\n        id\n      }\n    }\n  }\n  lineItemGroups {\n    lineItems {\n      __typename\n      ... on BookingLineItem {\n        appliedDiscounts {\n          amountCents\n          squareExternalDiscountId\n        }\n      }\n      ... on RoundLineItem {\n        appliedDiscounts {\n          amountCents\n          squareExternalDiscountId\n        }\n      }\n      id\n    }\n    id\n  }\n  serviceCharges {\n    edges {\n      node {\n        __typename\n        amount\n        id\n      }\n    }\n  }\n}\n\nfragment promoCodeAnalytics_booking on Booking {\n  __isBooking: __typename\n  type\n  appliedPromoCode {\n    code\n    category\n    discountType\n    discountAmount\n    id\n  }\n  startSlot {\n    __typename\n    agenda {\n      date\n      facility {\n        name\n        department {\n          type\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  promoCodeOrders: orders(first: 20, active: true) {\n    edges {\n      node {\n        ...getAggregatedOrderFinancialSummary_order\n        id\n      }\n    }\n  }\n}\n\nfragment useGetSummaryCalculations_Booking on Booking {\n  __isBooking: __typename\n  paymentRequirements {\n    prePaymentRequirement\n  }\n  id\n  __typename\n  totalDueAfterCredits\n  orders {\n    edges {\n      node {\n        status\n        total\n        orderPayments {\n          edges {\n            node {\n              amount\n              squareGiftCard {\n                id\n              }\n              id\n            }\n          }\n        }\n        ...getAggregatedOrderFinancialSummary_order\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b7cf57311f7d709d3cf41a2389771a86";

export default node;
